import { MakeCall } from '../createMakeCall';

import { CreatePropertyPayload, Property } from '../types/inventory/Property';

const createProperty =
  (makeCall: MakeCall) => (payload: CreatePropertyPayload) =>
    makeCall<Property>('POST', `/api/v2/property`, {
      data: payload,
    });
export { createProperty };
